const seenMarks = new Set<string>()
const seenMeasures = new Set<string>()

function canUsePerf() {
  return typeof window !== 'undefined' && typeof performance !== 'undefined'
}

export function markBoot(name: string) {
  if (!canUsePerf() || seenMarks.has(name)) return
  seenMarks.add(name)
  try {
    performance.mark(name)
  } catch {
    /* noop */
  }
}

export function measureBoot(name: string, start: string, end: string) {
  if (!canUsePerf() || seenMeasures.has(name)) return
  seenMeasures.add(name)
  try {
    performance.measure(name, start, end)
    const entries = performance.getEntriesByName(name, 'measure')
    const latest = entries[entries.length - 1]
    if (latest) {
      console.info(`[BootPerf] ${name}: ${Math.round(latest.duration)}ms`)
    }
  } catch {
    /* noop */
  }
}

export function markAndMeasure(name: string, start: string, end: string) {
  markBoot(end)
  measureBoot(name, start, end)
}
